import { useMelwaysInfo } from '@seek/melways-react';
import type { Market } from '@ts-internal/shared-lib';
import { useLocation } from 'react-router';

import {
  defaultPageNumber,
  defaultSearchQuery,
  defaultRoleTitles,
  defaultLocations,
  enabledMarkets,
} from './searchDefaults';

export const useSearchQueryParams = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const { country } = useMelwaysInfo();
  const defaultMarket = country?.toUpperCase() as Market;

  const searchQueryFromUrl = params.get('searchQuery') || defaultSearchQuery;

  const marketFromParams = params.get('market')?.toUpperCase() as Market;

  const marketFromUrl = enabledMarkets.includes(marketFromParams)
    ? marketFromParams
    : defaultMarket;

  const pageNumberFromUrl =
    Number(params.get('pageNumber')) || defaultPageNumber;

  const roleTitlesFromUrl =
    params.get('roleTitles')?.split(',') || defaultRoleTitles;

  const matchLatestRoleTitleFromUrl =
    params.get('matchLatestRoleTitle') === 'true';

  const locationsFromUrl =
    params.get('locations')?.split(',') || defaultLocations;

  const companiesFromUrl = params.get('companies')?.split(',') || [];

  const matchLatestCompanyFromUrl = params.get('matchLatestCompany') === 'true';

  return {
    searchQueryFromUrl,
    marketFromUrl,
    pageNumberFromUrl,
    roleTitlesFromUrl,
    matchLatestRoleTitleFromUrl,
    locationsFromUrl,
    companiesFromUrl,
    matchLatestCompanyFromUrl,
  };
};
